import { render, staticRenderFns } from "./cargo-tab.svg.vue?vue&type=template&id=ffe0755c&"
import script from "./cargo-tab.svg.vue?vue&type=script&lang=js&"
export * from "./cargo-tab.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports